import { render, staticRenderFns } from "./LifeEvents.vue?vue&type=template&id=3fbe3c08&scoped=true&"
import script from "./LifeEvents.vue?vue&type=script&lang=js&"
export * from "./LifeEvents.vue?vue&type=script&lang=js&"
import style0 from "./LifeEvents.vue?vue&type=style&index=0&id=3fbe3c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe3c08",
  null
  
)

export default component.exports